<template>
  <div id="stars"></div>
  <div id="stars2"></div>
  <div id="stars3"></div>
  <div id="title"></div>
  <div class="d-none d-xl-flex flex-column" style="min-height:100vh">
    <router-view style="flex-grow: 1;"/>
    <ScrumFooter/>
  </div>
  <div class="d-flex d-xl-none justify-content-center align-items-center" style="min-height:100vh">
    <h1 class="text-white text-center">請使用桌機版瀏覽以獲得更好的使用者體驗</h1>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import ScrumFooter from '@/components/ScrumFooter.vue';

export default {
  components: {
    ScrumFooter,
  },
};
</script>
<style lang="scss">
@font-face{
  font-family: custom-pixel;
  src: url(./assets/font/Cubic_11_1.013_R.ttf);
}
body {
  font-family: custom-pixel;
  height: 100%;
  background: #181e2a;
  overflow: hidden;
}
#stars {
  width: 1px;
  height: 1px;
  background: transparent;
  animation: animStar 50s linear infinite;
  box-shadow: 122px 1631px #fff, 1655px 1982px #fff, 1576px 1081px #fff,
    355px 844px #fff, 384px 1048px #fff, 288px 1502px #fff, 226px 462px #fff,
    1231px 9px #fff, 1514px 1703px #fff, 1997px 902px #fff, 1623px 624px #fff,
    796px 1879px #fff, 187px 1511px #fff, 224px 302px #fff, 682px 581px #fff,
    696px 1626px #fff, 957px 1090px #fff, 1858px 333px #fff, 667px 1328px #fff,
    14px 1540px #fff, 1558px 797px #fff, 762px 1795px #fff, 1754px 725px #fff,
    235px 616px #fff, 27px 1392px #fff, 1611px 1063px #fff, 936px 1459px #fff,
    328px 1101px #fff, 1221px 998px #fff, 611px 841px #fff, 1768px 1565px #fff,
    786px 1335px #fff, 1819px 242px #fff, 121px 614px #fff, 467px 256px #fff,
    1403px 353px #fff, 1634px 774px #fff, 654px 397px #fff, 1438px 194px #fff,
    1638px 507px #fff, 907px 1734px #fff, 1731px 201px #fff, 478px 51px #fff,
    1113px 1338px #fff, 1418px 1592px #fff, 419px 667px #fff, 1374px 812px #fff,
    459px 1937px #fff, 1687px 637px #fff, 601px 870px #fff, 1646px 1269px #fff,
    1185px 1173px #fff, 1896px 1472px #fff, 1717px 561px #fff, 1830px 911px #fff,
    1431px 317px #fff, 710px 152px #fff, 1772px 2000px #fff, 987px 1264px #fff,
    1386px 1495px #fff, 1985px 737px #fff, 1171px 523px #fff, 270px 69px #fff,
    920px 1430px #fff, 1421px 446px #fff, 528px 53px #fff, 1432px 119px #fff,
    1836px 1388px #fff, 555px 350px #fff, 1323px 385px #fff, 86px 1601px #fff,
    10px 1862px #fff, 1706px 628px #fff, 1267px 263px #fff, 857px 1088px #fff,
    975px 1529px #fff, 1531px 766px #fff, 367px 185px #fff, 200px 525px #fff,
    1209px 1239px #fff, 216px 295px #fff, 1143px 526px #fff, 1000px 1232px #fff,
    905px 1048px #fff, 1079px 975px #fff, 483px 1688px #fff, 63px 598px #fff,
    995px 1294px #fff, 1223px 1986px #fff, 835px 265px #fff, 382px 671px #fff,
    662px 1932px #fff, 1891px 260px #fff, 120px 1353px #fff, 158px 227px #fff,
    1272px 318px #fff, 1001px 558px #fff, 762px 1369px #fff, 1525px 249px #fff,
    1340px 1658px #fff, 136px 1097px #fff, 796px 1353px #fff, 1877px 1802px #fff,
    1087px 1621px #fff, 955px 1817px #fff, 961px 43px #fff, 1235px 977px #fff,
    278px 1176px #fff, 1141px 1889px #fff, 1171px 1623px #fff,
    1172px 1479px #fff, 1547px 1367px #fff, 879px 1010px #fff, 734px 208px #fff,
    925px 1972px #fff, 119px 1776px #fff, 1866px 1062px #fff, 548px 337px #fff,
    1794px 276px #fff, 283px 1808px #fff, 491px 266px #fff, 122px 1756px #fff,
    1883px 1196px #fff, 901px 965px #fff, 1939px 1215px #fff, 1592px 262px #fff,
    1854px 1769px #fff, 436px 174px #fff, 724px 717px #fff, 834px 1539px #fff,
    515px 983px #fff, 581px 969px #fff, 574px 332px #fff, 1732px 577px #fff,
    1385px 1630px #fff, 1476px 1765px #fff, 1219px 991px #fff,
    1370px 1548px #fff, 999px 1553px #fff, 918px 647px #fff, 1929px 1844px #fff,
    1737px 164px #fff, 1293px 488px #fff, 1705px 469px #fff, 419px 252px #fff,
    1359px 667px #fff, 1432px 988px #fff, 882px 903px #fff, 1138px 392px #fff,
    1178px 1305px #fff, 1272px 813px #fff, 1923px 1560px #fff,
    1397px 1701px #fff, 1335px 878px #fff, 495px 561px #fff, 741px 91px #fff,
    202px 1050px #fff, 1012px 1004px #fff, 1267px 962px #fff, 1491px 1891px #fff,
    2px 924px #fff, 570px 1169px #fff, 1874px 1320px #fff, 543px 1154px #fff,
    869px 330px #fff, 99px 465px #fff, 172px 746px #fff, 1114px 423px #fff,
    987px 1226px #fff, 1221px 1932px #fff, 732px 1463px #fff, 712px 1797px #fff,
    920px 1344px #fff, 1278px 1165px #fff, 869px 1069px #fff, 1043px 333px #fff,
    953px 1929px #fff, 861px 271px #fff, 1495px 663px #fff, 812px 912px #fff,
    1181px 116px #fff, 457px 919px #fff, 1512px 1468px #fff, 393px 550px #fff,
    308px 980px #fff, 8px 292px #fff, 1139px 1983px #fff, 1677px 300px #fff,
    1255px 1209px #fff, 973px 2px #fff, 643px 1354px #fff, 650px 816px #fff,
    394px 864px #fff, 1698px 685px #fff, 373px 1333px #fff, 323px 437px #fff,
    1005px 158px #fff, 90px 1484px #fff, 1518px 687px #fff, 212px 1428px #fff,
    942px 208px #fff, 9px 1985px #fff, 309px 83px #fff, 408px 1691px #fff,
    734px 449px #fff, 11px 1425px #fff, 1744px 1785px #fff, 218px 1560px #fff,
    1211px 1886px #fff, 856px 1549px #fff, 751px 971px #fff, 720px 970px #fff,
    1045px 1352px #fff, 1438px 824px #fff, 1341px 576px #fff, 426px 981px #fff,
    53px 1401px #fff, 1650px 1818px #fff, 85px 1069px #fff, 466px 1101px #fff,
    619px 607px #fff, 704px 447px #fff, 259px 1219px #fff, 1861px 405px #fff,
    982px 1176px #fff, 168px 1008px #fff, 1662px 1389px #fff, 1621px 1375px #fff,
    1986px 1856px #fff, 1943px 1532px #fff, 1143px 1065px #fff,
    1970px 745px #fff, 1631px 957px #fff, 1719px 591px #fff, 1940px 291px #fff,
    694px 1762px #fff, 1887px 1363px #fff, 406px 259px #fff, 1648px 1143px #fff,
    1539px 1513px #fff, 1837px 329px #fff, 1726px 1692px #fff,
    1271px 1421px #fff, 741px 1408px #fff, 1219px 952px #fff, 1401px 1399px #fff,
    1626px 795px #fff, 641px 341px #fff, 182px 1811px #fff, 1931px 1507px #fff,
    872px 187px #fff, 1474px 1987px #fff, 30px 272px #fff, 1644px 1504px #fff,
    1749px 986px #fff, 847px 1975px #fff, 502px 1287px #fff, 1691px 848px #fff,
    1865px 1833px #fff, 1459px 1619px #fff, 1362px 543px #fff,
    1230px 1533px #fff, 1301px 662px #fff, 1078px 703px #fff, 939px 1792px #fff,
    1778px 981px #fff, 554px 734px #fff, 1621px 1696px #fff, 1944px 1893px #fff,
    735px 992px #fff, 1343px 1243px #fff, 895px 1836px #fff, 1162px 1508px #fff,
    1336px 878px #fff, 91px 1377px #fff, 1366px 753px #fff, 416px 1901px #fff,
    698px 1964px #fff, 125px 115px #fff, 577px 198px #fff, 98px 1655px #fff,
    1021px 263px #fff, 1614px 1766px #fff, 1239px 1533px #fff, 1420px 104px #fff,
    186px 440px #fff, 1372px 1206px #fff, 1037px 1401px #fff, 739px 1273px #fff,
    746px 1687px #fff, 1900px 1373px #fff, 1342px 1449px #fff, 926px 115px #fff,
    1185px 1138px #fff, 986px 1936px #fff, 267px 170px #fff, 64px 853px #fff,
    1306px 25px #fff, 451px 1717px #fff, 661px 355px #fff, 1400px 146px #fff,
    87px 68px #fff, 1835px 1513px #fff, 881px 1564px #fff, 1172px 844px #fff,
    1994px 682px #fff, 1364px 1472px #fff, 1089px 529px #fff, 1525px 481px #fff,
    642px 1543px #fff, 1560px 927px #fff, 359px 417px #fff, 372px 1119px #fff,
    1125px 509px #fff, 1043px 583px #fff, 1325px 1712px #fff, 1386px 841px #fff,
    1860px 1692px #fff, 508px 941px #fff, 1497px 1341px #fff, 1764px 529px #fff,
    112px 189px #fff, 1682px 920px #fff, 1035px 1460px #fff, 1345px 31px #fff,
    1643px 1658px #fff, 1169px 1576px #fff, 1485px 604px #fff, 823px 821px #fff,
    689px 1088px #fff, 746px 783px #fff, 671px 1214px #fff, 237px 159px #fff,
    1637px 1398px #fff, 83px 1484px #fff, 1145px 1623px #fff, 1103px 770px #fff,
    1949px 648px #fff, 8px 867px #fff, 1290px 688px #fff, 447px 1311px #fff,
    1700px 746px #fff, 659px 1894px #fff, 579px 310px #fff, 725px 1230px #fff,
    138px 479px #fff, 731px 703px #fff, 978px 710px #fff, 1143px 1802px #fff,
    590px 1575px #fff, 1636px 1532px #fff, 1449px 273px #fff, 1415px 1595px #fff,
    1036px 588px #fff, 1153px 1712px #fff, 335px 1893px #fff, 292px 262px #fff,
    1819px 1226px #fff, 574px 1813px #fff, 1572px 500px #fff, 1028px 254px #fff,
    707px 702px #fff, 541px 1915px #fff, 60px 995px #fff, 1388px 317px #fff,
    1074px 46px #fff, 1752px 1946px #fff, 947px 481px #fff, 752px 158px #fff,
    1581px 630px #fff, 1196px 1788px #fff, 298px 1513px #fff, 1656px 86px #fff,
    1112px 924px #fff, 584px 1609px #fff, 1411px 839px #fff, 519px 850px #fff,
    1840px 3px #fff, 1278px 1622px #fff, 1040px 214px #fff, 1520px 628px #fff,
    465px 413px #fff, 1632px 1106px #fff, 454px 596px #fff, 1116px 1019px #fff,
    1593px 755px #fff, 1182px 1908px #fff, 310px 1127px #fff, 1925px 1510px #fff,
    739px 184px #fff, 398px 1149px #fff, 1759px 316px #fff, 781px 1906px #fff,
    298px 1739px #fff, 1171px 112px #fff, 1832px 998px #fff, 987px 704px #fff,
    1674px 1478px #fff, 1250px 1770px #fff, 1724px 1166px #fff,
    1454px 260px #fff, 1558px 1877px #fff, 1330px 275px #fff, 491px 1887px #fff,
    835px 37px #fff, 1372px 1249px #fff, 1120px 1488px #fff, 1819px 1534px #fff,
    407px 1227px #fff, 1058px 172px #fff, 760px 1654px #fff, 1367px 197px #fff,
    1918px 685px #fff, 473px 950px #fff, 756px 325px #fff, 1865px 1843px #fff,
    1752px 251px #fff, 438px 985px #fff, 1280px 1553px #fff, 798px 179px #fff,
    364px 1994px #fff, 1342px 338px #fff, 567px 826px #fff, 792px 1678px #fff,
    1711px 767px #fff, 1581px 1563px #fff, 1095px 1793px #fff, 516px 411px #fff,
    1074px 1044px #fff, 1594px 1334px #fff, 751px 1229px #fff, 294px 849px #fff,
    907px 443px #fff, 1370px 908px #fff, 245px 554px #fff, 1983px 1367px #fff,
    1084px 354px #fff, 818px 1146px #fff, 1368px 766px #fff, 1128px 638px #fff,
    1917px 531px #fff, 1060px 334px #fff, 801px 1269px #fff, 1510px 860px #fff,
    1094px 657px #fff, 1829px 1125px #fff, 105px 1640px #fff, 244px 342px #fff,
    939px 1989px #fff, 193px 696px #fff, 210px 1665px #fff, 948px 1949px #fff,
    487px 354px #fff, 1812px 1020px #fff, 744px 241px #fff, 1964px 1816px #fff,
    700px 1162px #fff, 1673px 357px #fff, 663px 1240px #fff, 1287px 262px #fff,
    1509px 705px #fff, 1962px 1426px #fff, 1034px 68px #fff, 1743px 296px #fff,
    889px 1510px #fff, 1387px 1668px #fff, 1772px 988px #fff, 267px 1818px #fff,
    227px 1727px #fff, 301px 188px #fff, 1292px 660px #fff, 1296px 1409px #fff,
    129px 1161px #fff, 1709px 1818px #fff, 642px 669px #fff, 1250px 317px #fff,
    1310px 243px #fff, 1168px 1670px #fff, 248px 5px #fff, 112px 101px #fff,
    1788px 959px #fff, 125px 416px #fff, 344px 588px #fff, 273px 1817px #fff,
    126px 1229px #fff, 1779px 1825px #fff, 1965px 1496px #fff, 1723px 843px #fff,
    1347px 1192px #fff, 1600px 369px #fff, 111px 322px #fff, 1742px 1998px #fff,
    783px 322px #fff, 1568px 657px #fff, 96px 895px #fff, 1542px 787px #fff,
    657px 1214px #fff, 1545px 857px #fff, 1732px 1907px #fff, 884px 955px #fff,
    1028px 400px #fff;
}
#stars:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 1px;
  height: 1px;
  background: transparent;
  box-shadow: 122px 1631px #fff, 1655px 1982px #fff, 1576px 1081px #fff,
    355px 844px #fff, 384px 1048px #fff, 288px 1502px #fff, 226px 462px #fff,
    1231px 9px #fff, 1514px 1703px #fff, 1997px 902px #fff, 1623px 624px #fff,
    796px 1879px #fff, 187px 1511px #fff, 224px 302px #fff, 682px 581px #fff,
    696px 1626px #fff, 957px 1090px #fff, 1858px 333px #fff, 667px 1328px #fff,
    14px 1540px #fff, 1558px 797px #fff, 762px 1795px #fff, 1754px 725px #fff,
    235px 616px #fff, 27px 1392px #fff, 1611px 1063px #fff, 936px 1459px #fff,
    328px 1101px #fff, 1221px 998px #fff, 611px 841px #fff, 1768px 1565px #fff,
    786px 1335px #fff, 1819px 242px #fff, 121px 614px #fff, 467px 256px #fff,
    1403px 353px #fff, 1634px 774px #fff, 654px 397px #fff, 1438px 194px #fff,
    1638px 507px #fff, 907px 1734px #fff, 1731px 201px #fff, 478px 51px #fff,
    1113px 1338px #fff, 1418px 1592px #fff, 419px 667px #fff, 1374px 812px #fff,
    459px 1937px #fff, 1687px 637px #fff, 601px 870px #fff, 1646px 1269px #fff,
    1185px 1173px #fff, 1896px 1472px #fff, 1717px 561px #fff, 1830px 911px #fff,
    1431px 317px #fff, 710px 152px #fff, 1772px 2000px #fff, 987px 1264px #fff,
    1386px 1495px #fff, 1985px 737px #fff, 1171px 523px #fff, 270px 69px #fff,
    920px 1430px #fff, 1421px 446px #fff, 528px 53px #fff, 1432px 119px #fff,
    1836px 1388px #fff, 555px 350px #fff, 1323px 385px #fff, 86px 1601px #fff,
    10px 1862px #fff, 1706px 628px #fff, 1267px 263px #fff, 857px 1088px #fff,
    975px 1529px #fff, 1531px 766px #fff, 367px 185px #fff, 200px 525px #fff,
    1209px 1239px #fff, 216px 295px #fff, 1143px 526px #fff, 1000px 1232px #fff,
    905px 1048px #fff, 1079px 975px #fff, 483px 1688px #fff, 63px 598px #fff,
    995px 1294px #fff, 1223px 1986px #fff, 835px 265px #fff, 382px 671px #fff,
    662px 1932px #fff, 1891px 260px #fff, 120px 1353px #fff, 158px 227px #fff,
    1272px 318px #fff, 1001px 558px #fff, 762px 1369px #fff, 1525px 249px #fff,
    1340px 1658px #fff, 136px 1097px #fff, 796px 1353px #fff, 1877px 1802px #fff,
    1087px 1621px #fff, 955px 1817px #fff, 961px 43px #fff, 1235px 977px #fff,
    278px 1176px #fff, 1141px 1889px #fff, 1171px 1623px #fff,
    1172px 1479px #fff, 1547px 1367px #fff, 879px 1010px #fff, 734px 208px #fff,
    925px 1972px #fff, 119px 1776px #fff, 1866px 1062px #fff, 548px 337px #fff,
    1794px 276px #fff, 283px 1808px #fff, 491px 266px #fff, 122px 1756px #fff,
    1883px 1196px #fff, 901px 965px #fff, 1939px 1215px #fff, 1592px 262px #fff,
    1854px 1769px #fff, 436px 174px #fff, 724px 717px #fff, 834px 1539px #fff,
    515px 983px #fff, 581px 969px #fff, 574px 332px #fff, 1732px 577px #fff,
    1385px 1630px #fff, 1476px 1765px #fff, 1219px 991px #fff,
    1370px 1548px #fff, 999px 1553px #fff, 918px 647px #fff, 1929px 1844px #fff,
    1737px 164px #fff, 1293px 488px #fff, 1705px 469px #fff, 419px 252px #fff,
    1359px 667px #fff, 1432px 988px #fff, 882px 903px #fff, 1138px 392px #fff,
    1178px 1305px #fff, 1272px 813px #fff, 1923px 1560px #fff,
    1397px 1701px #fff, 1335px 878px #fff, 495px 561px #fff, 741px 91px #fff,
    202px 1050px #fff, 1012px 1004px #fff, 1267px 962px #fff, 1491px 1891px #fff,
    2px 924px #fff, 570px 1169px #fff, 1874px 1320px #fff, 543px 1154px #fff,
    869px 330px #fff, 99px 465px #fff, 172px 746px #fff, 1114px 423px #fff,
    987px 1226px #fff, 1221px 1932px #fff, 732px 1463px #fff, 712px 1797px #fff,
    920px 1344px #fff, 1278px 1165px #fff, 869px 1069px #fff, 1043px 333px #fff,
    953px 1929px #fff, 861px 271px #fff, 1495px 663px #fff, 812px 912px #fff,
    1181px 116px #fff, 457px 919px #fff, 1512px 1468px #fff, 393px 550px #fff,
    308px 980px #fff, 8px 292px #fff, 1139px 1983px #fff, 1677px 300px #fff,
    1255px 1209px #fff, 973px 2px #fff, 643px 1354px #fff, 650px 816px #fff,
    394px 864px #fff, 1698px 685px #fff, 373px 1333px #fff, 323px 437px #fff,
    1005px 158px #fff, 90px 1484px #fff, 1518px 687px #fff, 212px 1428px #fff,
    942px 208px #fff, 9px 1985px #fff, 309px 83px #fff, 408px 1691px #fff,
    734px 449px #fff, 11px 1425px #fff, 1744px 1785px #fff, 218px 1560px #fff,
    1211px 1886px #fff, 856px 1549px #fff, 751px 971px #fff, 720px 970px #fff,
    1045px 1352px #fff, 1438px 824px #fff, 1341px 576px #fff, 426px 981px #fff,
    53px 1401px #fff, 1650px 1818px #fff, 85px 1069px #fff, 466px 1101px #fff,
    619px 607px #fff, 704px 447px #fff, 259px 1219px #fff, 1861px 405px #fff,
    982px 1176px #fff, 168px 1008px #fff, 1662px 1389px #fff, 1621px 1375px #fff,
    1986px 1856px #fff, 1943px 1532px #fff, 1143px 1065px #fff,
    1970px 745px #fff, 1631px 957px #fff, 1719px 591px #fff, 1940px 291px #fff,
    694px 1762px #fff, 1887px 1363px #fff, 406px 259px #fff, 1648px 1143px #fff,
    1539px 1513px #fff, 1837px 329px #fff, 1726px 1692px #fff,
    1271px 1421px #fff, 741px 1408px #fff, 1219px 952px #fff, 1401px 1399px #fff,
    1626px 795px #fff, 641px 341px #fff, 182px 1811px #fff, 1931px 1507px #fff,
    872px 187px #fff, 1474px 1987px #fff, 30px 272px #fff, 1644px 1504px #fff,
    1749px 986px #fff, 847px 1975px #fff, 502px 1287px #fff, 1691px 848px #fff,
    1865px 1833px #fff, 1459px 1619px #fff, 1362px 543px #fff,
    1230px 1533px #fff, 1301px 662px #fff, 1078px 703px #fff, 939px 1792px #fff,
    1778px 981px #fff, 554px 734px #fff, 1621px 1696px #fff, 1944px 1893px #fff,
    735px 992px #fff, 1343px 1243px #fff, 895px 1836px #fff, 1162px 1508px #fff,
    1336px 878px #fff, 91px 1377px #fff, 1366px 753px #fff, 416px 1901px #fff,
    698px 1964px #fff, 125px 115px #fff, 577px 198px #fff, 98px 1655px #fff,
    1021px 263px #fff, 1614px 1766px #fff, 1239px 1533px #fff, 1420px 104px #fff,
    186px 440px #fff, 1372px 1206px #fff, 1037px 1401px #fff, 739px 1273px #fff,
    746px 1687px #fff, 1900px 1373px #fff, 1342px 1449px #fff, 926px 115px #fff,
    1185px 1138px #fff, 986px 1936px #fff, 267px 170px #fff, 64px 853px #fff,
    1306px 25px #fff, 451px 1717px #fff, 661px 355px #fff, 1400px 146px #fff,
    87px 68px #fff, 1835px 1513px #fff, 881px 1564px #fff, 1172px 844px #fff,
    1994px 682px #fff, 1364px 1472px #fff, 1089px 529px #fff, 1525px 481px #fff,
    642px 1543px #fff, 1560px 927px #fff, 359px 417px #fff, 372px 1119px #fff,
    1125px 509px #fff, 1043px 583px #fff, 1325px 1712px #fff, 1386px 841px #fff,
    1860px 1692px #fff, 508px 941px #fff, 1497px 1341px #fff, 1764px 529px #fff,
    112px 189px #fff, 1682px 920px #fff, 1035px 1460px #fff, 1345px 31px #fff,
    1643px 1658px #fff, 1169px 1576px #fff, 1485px 604px #fff, 823px 821px #fff,
    689px 1088px #fff, 746px 783px #fff, 671px 1214px #fff, 237px 159px #fff,
    1637px 1398px #fff, 83px 1484px #fff, 1145px 1623px #fff, 1103px 770px #fff,
    1949px 648px #fff, 8px 867px #fff, 1290px 688px #fff, 447px 1311px #fff,
    1700px 746px #fff, 659px 1894px #fff, 579px 310px #fff, 725px 1230px #fff,
    138px 479px #fff, 731px 703px #fff, 978px 710px #fff, 1143px 1802px #fff,
    590px 1575px #fff, 1636px 1532px #fff, 1449px 273px #fff, 1415px 1595px #fff,
    1036px 588px #fff, 1153px 1712px #fff, 335px 1893px #fff, 292px 262px #fff,
    1819px 1226px #fff, 574px 1813px #fff, 1572px 500px #fff, 1028px 254px #fff,
    707px 702px #fff, 541px 1915px #fff, 60px 995px #fff, 1388px 317px #fff,
    1074px 46px #fff, 1752px 1946px #fff, 947px 481px #fff, 752px 158px #fff,
    1581px 630px #fff, 1196px 1788px #fff, 298px 1513px #fff, 1656px 86px #fff,
    1112px 924px #fff, 584px 1609px #fff, 1411px 839px #fff, 519px 850px #fff,
    1840px 3px #fff, 1278px 1622px #fff, 1040px 214px #fff, 1520px 628px #fff,
    465px 413px #fff, 1632px 1106px #fff, 454px 596px #fff, 1116px 1019px #fff,
    1593px 755px #fff, 1182px 1908px #fff, 310px 1127px #fff, 1925px 1510px #fff,
    739px 184px #fff, 398px 1149px #fff, 1759px 316px #fff, 781px 1906px #fff,
    298px 1739px #fff, 1171px 112px #fff, 1832px 998px #fff, 987px 704px #fff,
    1674px 1478px #fff, 1250px 1770px #fff, 1724px 1166px #fff,
    1454px 260px #fff, 1558px 1877px #fff, 1330px 275px #fff, 491px 1887px #fff,
    835px 37px #fff, 1372px 1249px #fff, 1120px 1488px #fff, 1819px 1534px #fff,
    407px 1227px #fff, 1058px 172px #fff, 760px 1654px #fff, 1367px 197px #fff,
    1918px 685px #fff, 473px 950px #fff, 756px 325px #fff, 1865px 1843px #fff,
    1752px 251px #fff, 438px 985px #fff, 1280px 1553px #fff, 798px 179px #fff,
    364px 1994px #fff, 1342px 338px #fff, 567px 826px #fff, 792px 1678px #fff,
    1711px 767px #fff, 1581px 1563px #fff, 1095px 1793px #fff, 516px 411px #fff,
    1074px 1044px #fff, 1594px 1334px #fff, 751px 1229px #fff, 294px 849px #fff,
    907px 443px #fff, 1370px 908px #fff, 245px 554px #fff, 1983px 1367px #fff,
    1084px 354px #fff, 818px 1146px #fff, 1368px 766px #fff, 1128px 638px #fff,
    1917px 531px #fff, 1060px 334px #fff, 801px 1269px #fff, 1510px 860px #fff,
    1094px 657px #fff, 1829px 1125px #fff, 105px 1640px #fff, 244px 342px #fff,
    939px 1989px #fff, 193px 696px #fff, 210px 1665px #fff, 948px 1949px #fff,
    487px 354px #fff, 1812px 1020px #fff, 744px 241px #fff, 1964px 1816px #fff,
    700px 1162px #fff, 1673px 357px #fff, 663px 1240px #fff, 1287px 262px #fff,
    1509px 705px #fff, 1962px 1426px #fff, 1034px 68px #fff, 1743px 296px #fff,
    889px 1510px #fff, 1387px 1668px #fff, 1772px 988px #fff, 267px 1818px #fff,
    227px 1727px #fff, 301px 188px #fff, 1292px 660px #fff, 1296px 1409px #fff,
    129px 1161px #fff, 1709px 1818px #fff, 642px 669px #fff, 1250px 317px #fff,
    1310px 243px #fff, 1168px 1670px #fff, 248px 5px #fff, 112px 101px #fff,
    1788px 959px #fff, 125px 416px #fff, 344px 588px #fff, 273px 1817px #fff,
    126px 1229px #fff, 1779px 1825px #fff, 1965px 1496px #fff, 1723px 843px #fff,
    1347px 1192px #fff, 1600px 369px #fff, 111px 322px #fff, 1742px 1998px #fff,
    783px 322px #fff, 1568px 657px #fff, 96px 895px #fff, 1542px 787px #fff,
    657px 1214px #fff, 1545px 857px #fff, 1732px 1907px #fff, 884px 955px #fff,
    1028px 400px #fff;
}
#stars2 {
  width: 2px;
  height: 2px;
  background: transparent;
  animation: animStar 100s linear infinite;
  box-shadow: 229px 927px #fff, 1206px 791px #fff, 535px 1914px #fff,
    98px 1522px #fff, 696px 1626px #fff, 957px 1090px #fff, 1858px 333px #fff,
    667px 1328px #fff, 14px 1540px #fff, 1558px 797px #fff, 762px 1795px #fff,
    1754px 725px #fff, 235px 616px #fff, 27px 1392px #fff, 1611px 1063px #fff,
    936px 1459px #fff, 328px 1101px #fff, 1221px 998px #fff, 611px 841px #fff,
    1768px 1565px #fff, 786px 1335px #fff, 1819px 242px #fff, 121px 614px #fff,
    467px 256px #fff, 1403px 353px #fff, 1634px 774px #fff, 654px 397px #fff,
    1438px 194px #fff, 1638px 507px #fff, 907px 1734px #fff, 1731px 201px #fff,
    478px 51px #fff, 1634px 774px #fff, 654px 397px #fff, 1438px 194px #fff,
    1638px 507px #fff, 907px 1734px #fff, 1731px 201px #fff, 478px 51px #fff,
    1113px 1338px #fff, 1418px 1592px #fff, 419px 667px #fff, 1374px 812px #fff,
    459px 1937px #fff, 1687px 637px #fff, 601px 870px #fff, 1646px 1269px #fff,
    1185px 1173px #fff, 1896px 1472px #fff, 1717px 561px #fff, 1830px 911px #fff,
    1431px 317px #fff, 710px 152px #fff, 1772px 2000px #fff, 987px 1264px #fff,
    1386px 1495px #fff, 1985px 737px #fff, 1171px 523px #fff, 270px 69px #fff,
    920px 1430px #fff, 1421px 446px #fff, 528px 53px #fff, 1432px 119px #fff,
    1836px 1388px #fff, 555px 350px #fff, 1323px 385px #fff, 86px 1601px #fff,
    10px 1862px #fff, 1706px 628px #fff, 1267px 263px #fff, 857px 1088px #fff,
    975px 1529px #fff, 1531px 766px #fff, 367px 185px #fff, 200px 525px #fff,
    1209px 1239px #fff, 216px 295px #fff, 1143px 526px #fff, 1000px 1232px #fff,
    905px 1048px #fff, 1079px 975px #fff, 483px 1688px #fff, 63px 598px #fff,
    995px 1294px #fff, 1223px 1986px #fff, 835px 265px #fff, 382px 671px #fff,
    662px 1932px #fff, 1891px 260px #fff, 120px 1353px #fff, 158px 227px #fff,
    1272px 318px #fff, 1001px 558px #fff, 762px 1369px #fff, 1525px 249px #fff,
    1340px 1658px #fff, 136px 1097px #fff, 796px 1353px #fff, 1877px 1802px #fff,
    1087px 1621px #fff, 955px 1817px #fff, 961px 43px #fff, 1235px 977px #fff,
    278px 1176px #fff, 1141px 1889px #fff, 1171px 1623px #fff,
    1172px 1479px #fff, 1547px 1367px #fff, 879px 1010px #fff, 734px 208px #fff;
}
#stars2:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 2px;
  height: 2px;
  background: transparent;
  box-shadow: 229px 927px #fff, 1206px 791px #fff, 535px 1914px #fff,
    98px 1522px #fff 43px #fff, 1235px 977px #fff, 278px 1176px #fff,
    1141px 1889px #fff, 1171px 1623px #fff, 1172px 1479px #fff,
    1547px 1367px #fff, 879px 1010px #fff, 734px 208px #fff, 925px 1972px #fff,
    119px 1776px #fff, 1866px 1062px #fff, 548px 337px #fff, 1794px 276px #fff,
    457px 919px #fff, 1512px 1468px #fff, 393px 550px #fff, 308px 980px #fff,
    8px 292px #fff, 1139px 1983px #fff, 1677px 300px #fff, 1255px 1209px #fff,
    973px 2px #fff, 643px 1354px #fff, 650px 816px #fff, 394px 864px #fff,
    1698px 685px #fff, 373px 1333px #fff, 323px 437px #fff, 1005px 158px #fff,
    90px 1484px #fff, 1518px 687px #fff, 212px 1428px #fff, 942px 208px #fff,
    9px 1985px #fff, 309px 83px #fff, 408px 1691px #fff, 734px 449px #fff,
    11px 1425px #fff, 1744px 1785px #fff, 218px 1560px #fff, 1211px 1886px #fff,
    856px 1549px #fff, 751px 971px #fff, 720px 970px #fff, 1045px 1352px #fff,
    1438px 824px #fff, 1341px 576px #fff, 426px 981px #fff, 53px 1401px #fff,
    1650px 1818px #fff, 85px 1069px #fff, 466px 1101px #fff, 619px 607px #fff,
    704px 447px #fff, 259px 1219px #fff, 1861px 405px #fff, 982px 1176px #fff,
    168px 1008px #fff, 1662px 1389px #fff, 1621px 1375px #fff,
    1986px 1856px #fff, 1943px 1532px #fff, 1143px 1065px #fff,
    1970px 745px #fff, 1631px 957px #fff, 1719px 591px #fff, 1940px 291px #fff,
    694px 1762px #fff, 1887px 1363px #fff, 406px 259px #fff, 1648px 1143px #fff,
    1539px 1513px #fff, 1837px 329px #fff, 1726px 1692px #fff,
    1271px 1421px #fff, 741px 1408px #fff, 1219px 952px #fff, 1401px 1399px #fff,
    1626px 795px #fff, 641px 341px #fff, 182px 1811px #fff, 1931px 1507px #fff,
    872px 187px #fff, 1474px 1987px #fff, 30px 272px #fff, 1644px 1504px #fff,
    1749px 986px #fff, 847px 1975px #fff, 502px 1287px #fff, 1691px 848px #fff,
    1865px 1833px #fff, 1459px 1619px #fff, 1362px 543px #fff,
    1230px 1533px #fff, 1301px 662px #fff, 1078px 703px #fff, 939px 1792px #fff,
    1778px 981px #fff, 554px 734px #fff, 1621px 1696px #fff, 1944px 1893px #fff,
    735px 992px #fff, 1343px 1243px #fff, 895px 1836px #fff, 1162px 1508px #fff,
    1336px 878px #fff, 91px 1377px #fff, 1366px 753px #fff, 416px 1901px #fff,
    698px 1964px #fff, 125px 115px #fff, 577px 198px #fff, 98px 1655px #fff,
    1021px 263px #fff, 1614px 1766px #fff, 1239px 1533px #fff, 1420px 104px #fff,
    186px 440px #fff, 1372px 1206px #fff, 1037px 1401px #fff, 739px 1273px #fff,
    746px 1687px #fff, 1900px 1373px #fff, 1342px 1449px #fff, 926px 115px #fff,
    1185px 1138px #fff, 986px 1936px #fff, 267px 170px #fff, 64px 853px #fff,
    1306px 25px #fff, 451px 1717px #fff, 661px 355px #fff, 1400px 146px #fff,
    87px 68px #fff, 1835px 1513px #fff, 881px 1564px #fff, 1172px 844px #fff,
    1994px 682px #fff, 1364px 1472px #fff, 1089px 529px #fff, 1525px 481px #fff,
    642px 1543px #fff, 1560px 927px #fff, 359px 417px #fff, 372px 1119px #fff,
    1125px 509px #fff, 1043px 583px #fff, 1325px 1712px #fff, 1386px 841px #fff,
    1860px 1692px #fff, 508px 941px #fff, 1497px 1341px #fff, 1764px 529px #fff,
    112px 189px #fff, 1682px 920px #fff, 1035px 1460px #fff, 1345px 31px #fff,
    1643px 1658px #fff, 1169px 1576px #fff, 1485px 604px #fff, 823px 821px #fff,
    689px 1088px #fff, 746px 783px #fff, 671px 1214px #fff, 237px 159px #fff,
    1637px 1398px #fff, 83px 1484px #fff, 1145px 1623px #fff, 1103px 770px #fff,
    1949px 648px #fff, 8px 867px #fff, 1290px 688px #fff, 447px 1311px #fff,
    1700px 746px #fff, 659px 1894px #fff, 579px 310px #fff, 725px 1230px #fff,
    138px 479px #fff, 731px 703px #fff, 978px 710px #fff, 1143px 1802px #fff,
    590px 1575px #fff, 1636px 1532px #fff, 1449px 273px #fff, 1415px 1595px #fff,
    1036px 588px #fff, 1153px 1712px #fff, 335px 1893px #fff, 292px 262px #fff,
    1819px 1226px #fff, 574px 1813px #fff, 1572px 500px #fff, 1028px 254px #fff,
    707px 702px #fff, 541px 1915px #fff, 60px 995px #fff, 1388px 317px #fff,
    1074px 46px #fff, 1752px 1946px #fff, 947px 481px #fff, 752px 158px #fff,
    1581px 630px #fff, 1196px 1788px #fff, 298px 1513px #fff, 1656px 86px #fff,
    1112px 924px #fff, 584px 1609px #fff, 1411px 839px #fff, 519px 850px #fff,
    1840px 3px #fff, 1278px 1622px #fff, 1040px 214px #fff, 1520px 628px #fff,
    465px 413px #fff, 1632px 1106px #fff, 454px 596px #fff, 1116px 1019px #fff,
    1593px 755px #fff, 1182px 1908px #fff, 310px 1127px #fff, 1925px 1510px #fff,
    739px 184px #fff, 398px 1149px #fff, 1759px 316px #fff, 781px 1906px #fff,
    298px 1739px #fff, 1171px 112px #fff, 1832px 998px #fff, 987px 704px #fff,
    1674px 1478px #fff, 1250px 1770px #fff, 1724px 1166px #fff,
    1454px 260px #fff, 1558px 1877px #fff, 1330px 275px #fff, 491px 1887px #fff,
    835px 37px #fff, 1372px 1249px #fff, 1120px 1488px #fff, 1819px 1534px #fff,
    407px 1227px #fff, 1058px 172px #fff, 760px 1654px #fff, 1367px 197px #fff,
    1918px 685px #fff, 473px 950px #fff, 756px 325px #fff, 1865px 1843px #fff,
    1752px 251px #fff, 438px 985px #fff, 1280px 1553px #fff, 798px 179px #fff,
    364px 1994px #fff, 1342px 338px #fff, 567px 826px #fff, 792px 1678px #fff,
    1711px 767px #fff, 1581px 1563px #fff, 1095px 1793px #fff, 516px 411px #fff,
    1074px 1044px #fff, 1594px 1334px #fff, 751px 1229px #fff, 294px 849px #fff,
    907px 443px #fff, 1370px 908px #fff, 245px 554px #fff, 1983px 1367px #fff,
    1084px 354px #fff, 818px 1146px #fff, 1368px 766px #fff, 1128px 638px #fff,
    1917px 531px #fff, 1060px 334px #fff, 801px 1269px #fff, 1510px 860px #fff,
    1094px 657px #fff, 1829px 1125px #fff, 105px 1640px #fff, 244px 342px #fff,
    939px 1989px #fff, 193px 696px #fff, 210px 1665px #fff, 948px 1949px #fff,
    487px 354px #fff, 1812px 1020px #fff, 744px 241px #fff, 1964px 1816px #fff,
    700px 1162px #fff, 1673px 357px #fff, 663px 1240px #fff, 1287px 262px #fff,
    1509px 705px #fff, 1962px 1426px #fff, 1034px 68px #fff, 1743px 296px #fff,
    889px 1510px #fff, 1387px 1668px #fff, 1772px 988px #fff, 267px 1818px #fff,
    227px 1727px #fff, 301px 188px #fff, 1292px 660px #fff, 1296px 1409px #fff,
    129px 1161px #fff, 1709px 1818px #fff, 642px 669px #fff, 1250px 317px #fff,
    1310px 243px #fff, 1168px 1670px #fff, 248px 5px #fff, 112px 101px #fff,
    1788px 959px #fff, 125px 416px #fff, 344px 588px #fff, 273px 1817px #fff,
    126px 1229px #fff, 1779px 1825px #fff, 1965px 1496px #fff, 1723px 843px #fff,
    1347px 1192px #fff, 1600px 369px #fff, 111px 322px #fff, 1742px 1998px #fff,
    783px 322px #fff, 1568px 657px #fff, 96px 895px #fff, 1542px 787px #fff,
    657px 1214px #fff, 1545px 857px #fff, 1732px 1907px #fff, 884px 955px #fff,
    1028px 400px #fff;
}
#stars3 {
  width: 3px;
  height: 3px;
  background: transparent;
  animation: animStar 150s linear infinite;
  box-shadow: 1349px 716px #fff, 1554px 1677px #fff, 1395px 1162px #fff,
    1807px 1757px #fff, 1113px 1625px #fff, 587px 708px #fff, 1110px 1743px #fff,
    1432px 1553px #fff, 1555px 1481px #fff, 275px 104px #fff, 306px 853px #fff,
    1794px 1711px #fff, 1520px 1410px #fff, 91px 916px #fff, 1737px 780px #fff,
    1852px 1882px #fff, 1499px 1083px #fff, 1786px 462px #fff,
    1756px 1488px #fff, 192px 86px #fff, 344px 51px #fff, 653px 791px #fff,
    1148px 1988px #fff, 1376px 947px #fff, 1632px 1925px #fff, 1285px 718px #fff,
    448px 1934px #fff, 515px 1716px #fff, 1544px 1161px #fff, 1188px 773px #fff,
    1517px 1540px #fff, 65px 1339px #fff, 201px 1589px #fff, 772px 1845px #fff,
    1933px 332px #fff, 1606px 1262px #fff, 223px 1186px #fff, 521px 140px #fff,
    983px 298px #fff, 1861px 98px #fff, 1893px 1977px #fff, 1038px 471px #fff,
    1540px 1079px #fff, 677px 993px #fff, 598px 798px #fff, 794px 1823px #fff,
    1412px 151px #fff, 1774px 39px #fff, 989px 18px #fff, 1087px 1207px #fff,
    207px 1983px #fff, 1338px 1329px #fff, 824px 1388px #fff, 336px 1341px #fff,
    481px 1807px #fff, 1562px 1895px #fff, 632px 1908px #fff, 732px 1137px #fff,
    141px 1906px #fff, 1941px 752px #fff, 830px 1911px #fff, 1996px 972px #fff,
    1464px 1436px #fff, 1020px 1903px #fff, 1249px 421px #fff, 982px 1944px #fff,
    646px 1950px #fff, 1880px 1050px #fff, 908px 788px #fff, 1860px 1748px #fff,
    368px 370px #fff, 1691px 584px #fff, 1692px 1460px #fff, 1572px 116px #fff,
    1819px 1124px #fff, 917px 859px #fff, 823px 826px #fff, 896px 1171px #fff,
    1924px 1902px #fff, 339px 864px #fff, 1154px 1586px #fff, 156px 910px #fff,
    1487px 562px #fff, 1279px 1201px #fff, 1218px 1906px #fff,
    1285px 1534px #fff, 1693px 935px #fff, 651px 1655px #fff, 1437px 1267px #fff,
    1199px 476px #fff, 1798px 1877px #fff, 1135px 1634px #fff,
    1868px 1259px #fff, 971px 1047px #fff, 1653px 1723px #fff, 784px 1087px #fff,
    706px 1959px #fff, 1070px 1349px #fff, 298px 111px #fff, 1697px 1106px #fff;
}
#stars3:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 3px;
  height: 3px;
  background: transparent;
  box-shadow: 1349px 716px #fff, 1554px 1677px #fff, 1395px 1162px #fff,
    1807px 1757px #fff, 1113px 1625px #fff, 587px 708px #fff, 1110px 1743px #fff,
    1432px 1553px #fff, 1555px 1481px #fff, 275px 104px #fff, 306px 853px #fff,
    1794px 1711px #fff, 1520px 1410px #fff, 91px 916px #fff, 1737px 780px #fff,
    1852px 1882px #fff, 1499px 1083px #fff, 1786px 462px #fff,
    1756px 1488px #fff, 192px 86px #fff, 344px 51px #fff, 653px 791px #fff,
    1148px 1988px #fff, 1376px 947px #fff, 1632px 1925px #fff, 1285px 718px #fff,
    448px 1934px #fff, 515px 1716px #fff, 1544px 1161px #fff, 1188px 773px #fff,
    1517px 1540px #fff, 65px 1339px #fff, 201px 1589px #fff, 772px 1845px #fff,
    1933px 332px #fff, 1606px 1262px #fff, 223px 1186px #fff, 521px 140px #fff,
    983px 298px #fff, 1861px 98px #fff, 1893px 1977px #fff, 1038px 471px #fff,
    1540px 1079px #fff, 677px 993px #fff, 598px 798px #fff, 794px 1823px #fff,
    1412px 151px #fff, 1774px 39px #fff, 989px 18px #fff, 1087px 1207px #fff,
    207px 1983px #fff, 1338px 1329px #fff, 824px 1388px #fff, 336px 1341px #fff,
    481px 1807px #fff, 1562px 1895px #fff, 632px 1908px #fff, 732px 1137px #fff,
    141px 1906px #fff, 1941px 752px #fff, 830px 1911px #fff, 1996px 972px #fff,
    1464px 1436px #fff, 1020px 1903px #fff, 1249px 421px #fff, 982px 1944px #fff,
    646px 1950px #fff, 1880px 1050px #fff, 908px 788px #fff, 1860px 1748px #fff,
    368px 370px #fff, 1691px 584px #fff, 1692px 1460px #fff, 1572px 116px #fff,
    1819px 1124px #fff, 917px 859px #fff, 823px 826px #fff, 896px 1171px #fff,
    1924px 1902px #fff, 339px 864px #fff, 1154px 1586px #fff, 156px 910px #fff,
    1487px 562px #fff, 1279px 1201px #fff, 1218px 1906px #fff,
    1285px 1534px #fff, 1693px 935px #fff, 651px 1655px #fff, 1437px 1267px #fff,
    1199px 476px #fff, 1798px 1877px #fff, 1135px 1634px #fff,
    1868px 1259px #fff, 971px 1047px #fff, 1653px 1723px #fff, 784px 1087px #fff,
    706px 1959px #fff, 1070px 1349px #fff, 298px 111px #fff, 1697px 1106px #fff;
}

@keyframes animStar {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-2000px);
  }
}
</style>
